import { BasicLayout } from '@/components/layouts';
import pluginConst from '@/utils/const/plugin';

export default {
  path: '/plugin',
  name: 'Plugin',
  component: BasicLayout,
  redirectToChild: true,
  meta: {
    title: '插件',
    icon: 'iconcalendar',
  },
  children: [
    {
      path: '/plugin/order',
      name: 'Plugin.order',
      component: () => import('@/views/modules/plugin/order.vue'),
      meta: {
        title: '订单查询',
        icon: 'icon-dingdanchaxun',
        authorities: pluginConst.orderId,
      },
    },
    {
      path: '/plugin/scheme',
      name: 'Plugin.scheme',
      component: () => import('@/views/modules/plugin/scheme.vue'),
      meta: {
        title: '优秀方案',
        icon: 'icon-youxiufangan',
        authorities: pluginConst.schemeId,
      },
    },
    {
      path: '/plugin/list',
      name: 'Plugin.List',
      component: () => import('@/views/modules/plugin/list.vue'),
      meta: {
        title: '添加功能插件',
        icon: 'icon-plus',
        special: true,
      },
    },
  ],
};


export const mobileFullScreen = {
  path: '/plugin/scheme/mobile-preivew',
  name: 'Plugin.mobilePreivew',
  hiddenInMenu: true,
  component: () => import('@/views/modules/plugin/mobileFullScreen.vue'),
  meta: {
    title: '优秀方案-mobile',
  },
};
